module.exports = __webpack_public_path__ + "static/media/2021_cadillac_ct5_ext_06_6DD79_1SE_GSK.1605be59.png";